import React from "react";

const Filter = ({ filterText, onFilter, onClear }) => {
  return (
    <>
      <input type="hidden" autoComplete="off" />
    </>
  );
};

export default Filter;
